import { ApiState } from "@/store/general.types";
import { CitationState, UserDetail } from "./citation.types";
import { mutate } from "@/store/plugins/mutation-handler";

export const citationMutations = {
    GET_USER_MUTATION(state: CitationState, newState: ApiState<UserDetail>) {
        mutate(state, newState, 'getUser');
    },
}